import { packageSpecs } from '@/mocks/home';

export default function PackageSpec() {
  return (
    <section id="package" className="w-full bg-background-50">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-8 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-4">
          <span className="font-label text-xs tracking-[0.2em] text-primary-600">PACKAGE / 安装包</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            安装包基础信息与校验说明
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            下载前可先核对版本、体积与兼容系统。安装包支持文件校验，安装时如提示来源未知，属于正常情况，可先行比对再继续。
          </p>
          <div className="mt-6 rounded-lg border border-secondary-200 bg-secondary-50 p-4">
            <div className="flex items-start gap-3">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary-200 text-secondary-900">
                <i className="ri-information-line text-base" />
              </span>
              <p className="text-xs leading-6 text-foreground-600">
                官方安装包不会要求额外权限或填写账号密码，请以本页渠道为准。
              </p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:gap-4">
            {packageSpecs.map((spec) => (
              <div
                key={spec.label}
                className="flex items-start gap-3.5 rounded-lg border border-background-200 bg-background-100/60 px-4 py-4"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-background-50 text-primary-600">
                  <i className={`${spec.icon} text-lg`} />
                </span>
                <div className="min-w-0">
                  <div className="font-label text-xs text-foreground-500">{spec.label}</div>
                  <div className="mt-1 text-sm font-medium leading-6 text-foreground-900">{spec.value}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}